import { useState } from "react";

const ADD_NEW = "__add_new__";

// A <select> that lets the user add a brand-new option inline instead of
// being limited to the fixed list — pick "+ Add new…" to type a value,
// which is persisted via onAddNew and immediately selected.
export default function EditableSelect({ value, onChange, options, onAddNew, className = "", style }) {
  const [adding, setAdding] = useState(false);
  const [newValue, setNewValue] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSelectChange = (e) => {
    if (e.target.value === ADD_NEW) {
      setNewValue("");
      setAdding(true);
    } else {
      onChange(e.target.value);
    }
  };

  const saveNew = async () => {
    const v = newValue.trim();
    if (!v) { setAdding(false); return; }
    setSaving(true);
    try {
      await onAddNew(v);
      onChange(v);
      setAdding(false);
    } finally {
      setSaving(false);
    }
  };

  if (adding) {
    return (
      <div style={{ display: "flex", gap: 6, ...style }}>
        <input
          autoFocus
          className={className}
          style={{ flex: 1 }}
          value={newValue}
          disabled={saving}
          onChange={e => setNewValue(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter") { e.preventDefault(); saveNew(); }
            if (e.key === "Escape") setAdding(false);
          }}
          placeholder="Type new value…"
        />
        <button type="button" onClick={saveNew} disabled={saving}
                style={{ padding: "0 10px", borderRadius: 6, border: "none", background: "#059669",
                         color: "#f0fdf4", cursor: saving ? "not-allowed" : "pointer", fontWeight: 600 }}>
          ✓
        </button>
        <button type="button" onClick={() => setAdding(false)} disabled={saving}
                style={{ padding: "0 10px", borderRadius: 6, border: "1px solid #c0d0eb",
                         background: "none", color: "#2a4a78", cursor: "pointer" }}>
          ✕
        </button>
      </div>
    );
  }

  return (
    <select className={className} style={style} value={value} onChange={handleSelectChange}>
      {options.map(o => <option key={o} value={o}>{o}</option>)}
      <option value={ADD_NEW}>+ Add new…</option>
    </select>
  );
}
